import { render, staticRenderFns } from "./TimelineItemStatus.vue?vue&type=template&id=dab20dfe&scoped=true"
import script from "./TimelineItemStatus.vue?vue&type=script&lang=ts"
export * from "./TimelineItemStatus.vue?vue&type=script&lang=ts"
import style0 from "./TimelineItemStatus.vue?vue&type=style&index=0&id=dab20dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab20dfe",
  null
  
)

export default component.exports